
import React, { useContext, useState } from "react";
import { resetPassword, signInUser, signInWithGoogle } from '../../api/api';
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";
import { AppContext } from "../../appContext";

export const LoginPage = () => {
    const {translate} = useContext(AppContext);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const [isRemember, setRemember] = useState(false);
    const {cheat} = useContext(AppContext);

    const handleLogin = async ()=>{
        try {
            await signInUser(email, password);
            navigate('/dashboard');
        } catch (error) {
            // Check if account is disabled
            if (error.code === 'auth/user-disabled') {
                alert(translate('account_disabled'));
                return;
            }
            alert(error.message);
        }
    }

    const loginWithGoogle = async () => {
        try {
            await signInWithGoogle();
            navigate('/dashboard');
        } catch (error) {
            // Check if account is disabled
            if (error.code === 'auth/user-disabled') {
                alert(translate('account_disabled'));
                return;
            }
            alert(error.message);
        }
    }

    const checkRemember = () => {
        setRemember(last=>!last);
    }

    const clickForgetPassword = () => {
        resetPassword(email);
    }

    const clickSignUp= () => {
        navigate('/sign-up');
    }

    return (
        <div className="loginPage">
            <div className="loginPage_background">
            
            </div>
            <div className="loginPage_wrapper">
                <div className="loginPage_header">
                    <div className="loginPage_logo">{translate('login_Appname')}</div>
                    {cheat.debug && <div className="button loginPage_signUp" onClick={clickSignUp}>{translate('login_sign_up')}</div>}
                </div>
                <div className="loginPage_main">
                    <div className="loginPopup">
                        <div className="loginPopup_title">
                            {translate('login_LoginText')}
                        </div>
                        <div className="loginPopup_form">
                            <div className="loginPopup_input">
                                <div className="loginPopup_input_label">
                                    {translate('login_email')}
                                </div>
                                <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} className="loginPopup_input_field" />
                            </div>
                            <div className="loginPopup_input">
                                <div className="loginPopup_input_label">
                                    {translate('login_password')}
                                </div>
                                <input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} className="loginPopup_input_field" />
                            </div>
                            <div className="loginPopup_remember">
                                <div className={`button loginPopup_check ${isRemember ? 'loginPopup_check--checked' : ''}`} onClick={checkRemember}>
                                    <div className="loginPopup_check_box">
                                    
                                    </div>
                                    <div className="loginPopup_check_label">
                                        {translate('login_remember_me')}
                                    </div>
                                </div>
                                <div className="button loginPopup_forgotPassword" onClick={clickForgetPassword}>
                                    {translate('login_forgot_password')}
                                </div>
                            </div>
                            <div className="button saveButton loginPopup_submit" onClick={handleLogin}>
                                {translate('login_proceed')}
                            </div>
                        </div>
                        {/* <div className="loginPopup_otherAuth">
                            <div className="loginPopup_otherAuth_or">
                                or
                            </div>
                            <div className="button loginPopup_otherAuth_google" onClick={loginWithGoogle}>
                                <div className="loginPopup_otherAuth_google_ico">

                                </div>
                                <div className="loginPopup_otherAuth_google_text">
                                    Sign in with Google
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className="loginPage_footer">
                    <div className="loginPage_footer_text">
                        © 2021. - 2025 {translate('login_AllRightsText')}
                    </div>
                </div>
            </div>
        </div>
    )
}
